import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Each item in `warnings` can be either:
 *  - a string (rendered as severity="warning")
 *  - an object { message, severity } where severity is "warning" | "info"
 */
function RadioWarningDialog({ open, onClose, onConfirm, warnings = [] }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('sites.radioChangeWarning', 'Warning')}</DialogTitle>
      <DialogContent>
        {warnings.map((warning, index) => {
          const isObject = typeof warning === 'object' && warning !== null;
          const message = isObject ? warning.message : warning;
          const severity = isObject ? warning.severity || 'warning' : 'warning';
          const icon = severity === 'info' ? <InfoOutlinedIcon /> : <WarningAmberIcon />;

          return (
            <Alert key={index} severity={severity} icon={icon} sx={{ mb: index < warnings.length - 1 ? 2 : 0 }}>
              <Typography variant="body2">{message}</Typography>
            </Alert>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('actions.cancel')}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('actions.ok', 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RadioWarningDialog;
